import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener
} from "@angular/core";
import {ROUTES} from './vertical-menu-routes.config';
import { HROUTES } from '../horizontal-menu/navigation-routes.config';

import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { LayoutService } from '../services/layout.service';
import {AuthService} from '../../services/auth/auth.service';
import {RouteInfo} from './vertical-menu.metadata';
import {ConstantsProviders} from '../../services/constants';
import {ACTIVE_COMPANY, Empresa} from '../../services/company-config';

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;
  logoUrl = ConstantsProviders.AppLogoDisplay;
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  public appDisplayName = ConstantsProviders.AppNameDisplay;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    public auth: AuthService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }


  ngOnInit() {
    // this.menuItems = ROUTES;
    this.switchMenu();
  }

  ngAfterViewInit() {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();
      this.cdr.detectChanges(); // Forzar la detección de cambios aquí
    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      });

  }


  switchMenu() {
    const role: string = this.auth.usuarioDTO.role;
    const userId = this.auth.getUsuariosId().trim().toLowerCase();
    const isAntonio = userId === 'antonio';
    const canSeeTaxi2424FareAndZones = ACTIVE_COMPANY !== Empresa.EcoGroupRivera || userId === 'luis';
    const permisos = this.auth.usuarioDTO.programs_dispatch.programname
      .map((permission: string) => permission.trim())
      .map((permission: string) => permission === 'zone' ? 'ctrlzones' : permission)
      .filter((permission: string) => !isAntonio || permission !== 'admingx');
    let menuRoutes = isAntonio ? this.filterAdministrationMenu(ROUTES) : ROUTES;
    menuRoutes = canSeeTaxi2424FareAndZones ? menuRoutes : this.filterTaxi2424FareAndZonesMenu(menuRoutes);
    // console.log('Role:', role); // Registro del rol
    // console.log('Permissions:', permisos); // Registro de permisos

    if (role.trim() === 'OwnerCab') {
      this.menuItems = menuRoutes;
    } else {
      this.menuItems = this.filterMenuByPermissions(menuRoutes, permisos);
    }
    // console.log('Menu Items:', this.menuItems); // Registro de los elementos del menú
    this.cdr.detectChanges();
  }


  filterMenuByPermissions(menu: RouteInfo[], permissions: string[]): RouteInfo[] {
    // console.log(JSON.stringify(menu));
    // console.log(JSON.stringify(permissions));
    return menu
      .map(item => {
        const submenu = item.submenu && item.submenu.length > 0
          ? this.filterMenuByPermissions(item.submenu, permissions)
          : [];

        return {
          ...item,
          submenu
        };
      })
      .filter(item => {
        if (permissions.includes(item.idpm)) {
          return true;
        }
        if (item.submenu && item.submenu.length > 0) {
          return true;
        }
        return false;
      });
  }

  filterAdministrationMenu(menu: RouteInfo[]): RouteInfo[] {
    return menu
      .filter(item => item.idpm !== 'admingx')
      .map(item => ({
        ...item,
        submenu: item.submenu && item.submenu.length > 0
          ? this.filterAdministrationMenu(item.submenu)
          : []
      }));
  }

  filterTaxi2424FareAndZonesMenu(menu: RouteInfo[]): RouteInfo[] {
    return menu
      .map(item => ({
        ...item,
        submenu: item.submenu && item.submenu.length > 0
          ? this.filterTaxi2424FareAndZonesMenu(item.submenu)
          : []
      }))
      .filter(item => item.path !== '/page/fare' && item.path !== '/page/zones')
      .filter(item => item.submenu.length > 0 || item.path !== '');
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
      if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout((() => {
        this.innerWidth = event.target.innerWidth;
          this.loadLayout();
      }).bind(this), 500);
  }

  loadLayout() {

    if (this.config.layout.menuPosition === "Top") { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        this.menuItems = HROUTES;
      }
    }
    else if (this.config.layout.menuPosition === "Side") { // Vertical Menu{
      // this.menuItems = ROUTES;
      this.switchMenu();
    }




    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logo-dark.png';
    }
    else {
      this.logoUrl = ConstantsProviders.AppLogoDisplay
    }

    if(this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    }
    else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    }
    else {
      this.perfectScrollbarEnable = true;
    }

  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }

}
